var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mwe-loading",class:{
    'mwe-loading-min-height': _vm.minHeight
  },style:({
    'min-height': _vm.minHeight
  })},[_c('div',{staticClass:"spinner-item"},[_vm._m(0),(_vm._title)?_c('div',{staticClass:"spinner-title"},[_vm._v(_vm._s(_vm._title))]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-circle"},[_c('div',{staticClass:"circle"})])}]

export { render, staticRenderFns }